// simple wrapper for emoji-mart
// don't forget to call useEmojis in app root
import React from 'react'

function Emoji(props) {
  return <em-emoji {...props} />
}

export default Emoji
